// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import some from 'lodash/some';
import clone from 'lodash/clone';

// Atoms
import Select from 'atoms/Select';

// Components
import { ScrollFormSection } from 'components/ScrollForm';

export default class SelectsSection extends Component {
  static propTypes = {
    defaultValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectProps: PropTypes.arrayOf(PropTypes.object),
    validators: PropTypes.arrayOf(PropTypes.object).isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  constructor({ defaultValues }) {
    super();
    this.inputs = [];
    this.state = {
      values: defaultValues
    };
  }

  canSectionSubmit = () => {
    const { validators } = this.props;
    return !some(validators, v => v.isInvalid);
  };

  handleSelectChange(ev, selectIndex, props) {
    const values = clone(this.state.values);
    values[selectIndex] = ev.target.value;

    this.setState({ values });
    if ('onChange' in props) {
      props.onChange(ev);
    }
  }

  handleSelectKeyDown(ev, index) {
    const nextInput = this.inputs[index + 1];
    if (ev.key === 'Enter' && nextInput) {
      // Prevent section form submit
      ev.preventDefault();
      if (ev.target.value) {
        nextInput.focus();
      }
    }
  }

  handleSectionActivation = () => {
    setImmediate(() => {
      document.activeElement.blur();
    });
  };

  inputRef(input, index) {
    this.inputs[index] = input;
  }

  renderSelect(index) {
    const { values } = this.state;
    const { validators, selectProps, items } = this.props;
    const value = values[index];
    const validator = validators[index];
    const props = selectProps[index];

    return (
      <Select
        {...props}
        key={index}
        fullWidth
        value={value}
        items={items}
        margin="normal"
        inputRef={input => this.inputRef(input, index)}
        onKeyDown={ev => this.handleSelectKeyDown(ev, index)}
        onChange={ev => this.handleSelectChange(ev, index, props)}
        validator={validator}
        preserveErrorSpace
      />
    );
  }

  render() {
    const { defaultValues, validators, selectProps, ...rest } = this.props;
    const { values } = this.state;
    const hideNextButton = some(values, v => v === '');

    return (
      <ScrollFormSection
        {...rest}
        onActivation={this.handleSectionActivation}
        canSubmit={this.canSectionSubmit}
        hideNextButton={hideNextButton}
      >
        { values.map((v, index) => this.renderSelect(index)) }
      </ScrollFormSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollForm/Sections/Selects/index.js